import { FunctionComponent } from 'react';
import { DefaultScreen } from './DefaultScreen';
import { MainContainer } from './MainContainer';
import { useExtendedIntl } from 'hooks/useExtendedIntl';
import { ReactComponent as ExpiredLinkSVG } from 'images/link-expired.svg';
import { LocalizedIntlProvider } from 'i18n/LocalizedIntlProvider';

export const Content: FunctionComponent = () => {
  const { formatMessage } = useExtendedIntl();

  return (
    <DefaultScreen
      SVG={ExpiredLinkSVG}
      title={formatMessage({ id: 'shared.something-went-wrong-message' }, { br: <br /> })}
      description={formatMessage({ id: 'shared.something-went-wrong-description' }, { br: <br /> })}
      CTAButtonProps={{
        onClick: () => window.location.reload(),
        children: formatMessage({ id: 'shared.error-loading-page.button' }),
      }}
    />
  );
};

export const ErrorLoadingPage: FunctionComponent = () => {
  return (
    <LocalizedIntlProvider>
      <MainContainer sx={{ pt: { xs: 2, sm: 4, md: 6 } }}>
        <Content />
      </MainContainer>
    </LocalizedIntlProvider>
  );
};
